import { Outlet, useParams } from 'react-router-dom';

import { OrgDetailHeader } from '../components/OrgDetailHeader';

/**
 * Layout route for `/organizations/:orgId` (design §5.1): the org header + tabs,
 * then the tab's page through `<Outlet/>`. Its index route redirects to
 * `projects` — the end user's most frequent destination — so the selected tab is
 * always backed by a real URL.
 */
export function OrganizationDetailPage() {
  const { orgId = '' } = useParams<{ orgId: string }>();

  return (
    <div>
      <OrgDetailHeader orgId={orgId} />
      <Outlet />
    </div>
  );
}
